/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";
const DeliveryDashboard = () => {
    const embeddedId = "7706b77d-272a-4a20-a165-d471c7952438";
    const rsl = [];//datasource_id=721   
    const title = "Delivery Dashboard";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default DeliveryDashboard;
